// auth.interceptor.ts
import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable, from } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Lazily resolve AuthService to avoid circular/timing issues
    const authService = this.injector.get(AuthService);

    // Convert the Promise<string|null> into an Observable<string|null>
    return from(authService.getToken()).pipe(
      switchMap((token) => {
        // If we got a token, clone the request and set the header
        const authReq = token
          ? req.clone({
              headers: req.headers.set("Authorization", `Bearer ${token}`),
            })
          : req;
        // Pass on the (possibly cloned) request
        return next.handle(authReq);
      }),
      // If getToken() itself throws or rejects, just continue without auth header
      catchError(() => next.handle(req))
    );
  }
}
